import Icon from '@cobliteam/ui/icons';
import { parseContent } from '../../../helpers';
import useSearch from '../../../hooks/useSearch';
import type { ArticleWithCategory } from '../../../types';

const DOMAIN = 'https://suporte.cobli.co';

const ArticleDetails = () => {
  const { selectedItem } = useSearch();
  if (!selectedItem) return null;

  const item = selectedItem as ArticleWithCategory;

  return (
    <div className='relative flex h-[500px] w-full flex-col gap-4 overflow-hidden overflow-y-auto p-4'>
      <div className='flex items-center gap-2'>
        <div className='rounded-md bg-primary-4 p-2'>
          <Icon name={item.category.icon} className='size-4' />
        </div>
      </div>

      <div className='font-semibold text-base'>{item?.title}</div>

      <div className='max-h-[360px] max-w-none overflow-y-auto text-xs'>{parseContent(item.content)}</div>

      <a href={`${DOMAIN}${item.path}`} target='_blank' rel='noopener noreferrer' className='mt-2 font-medium text-primary text-xs hover:underline'>
        Ver mais detalhes
      </a>
    </div>
  );
};

export default ArticleDetails;
